import { format } from 'date-fns';
import * as React from 'react';
import { actions } from 'react-redux-form';
import { store } from '../../../store';
import { dispatch } from '../../../utils/generalUtils';
import { RDatePicker } from '../../reusableComponents/DatePicker';
import { InputRow } from '../../reusableComponents/FormComponents/InputRow';

export interface IRenderQuestionProps {
    quesNo?: string;
    question?: string;
    type?: string;
    isYes?: boolean;
    isNA?: boolean;
    buttons?: {
        label: string,
        value: string
    }[];
    model?: string;
    isCheck?: boolean;
    questionType?: string;
    uniqueValue?: number;
    containsComment?: boolean;
    CommentQuestion?: string;
    CommentQuestionNum?: number;
    classIndex?: number;
    onChange?: Function;
    CommentQuestionLabel?: string;
    formId?: string;
    customLabel?: string;
    formType?: string;
    customLabelForComments?: string;
    className?: string;
}
export interface IRenderQuestionState {
    classNameIndex: number;
    isYes: string;
    defaultComment: string;
    date: Date;
    isDateTouched: boolean;
}
export class RenderQuestion extends React.PureComponent<IRenderQuestionProps, IRenderQuestionState> {
    constructor(props: IRenderQuestionProps) {
        super(props);
        this.state = {
            date: null,
            defaultComment: '', isDateTouched: false,
            classNameIndex: null, isYes: null
        };
    }

    handleButtons = (value, index, quesNo, model) => {
        this.setState({ classNameIndex: index, isYes: value,
        defaultComment: value === 'Y*' && ''
        });
        dispatch(actions.change(`forms.${model}.${quesNo}`, value));
        if (this.props.onChange) {
            if (this.props.containsComment && value === 'No') {
                dispatch(actions.change(`${model}.${Number(quesNo) + 1}`, null));
            }
            this.props.onChange(value, quesNo);
        }
    }

    loadDefaultValues = (state, model) => {
        const { state: { date, isDateTouched },
            props: { buttons, CommentQuestionNum, CommentQuestion, questionType, formId, formType } } = this;
        const answerValue = state.forms[model][this.props.quesNo];
        if (formId) {
            if ((buttons || []).length > 2) {
                let classNameIndex = null; 
                switch(answerValue) {
                    case 'Yes': classNameIndex = 0; break;
                    case 'No': classNameIndex = 1; break;
                    case 'N/A': classNameIndex = 2; break;
                    default: classNameIndex = null; break;
                } 
                this.setState({
                    //classNameIndex:  answerValue ? answerValue === 'Yes' ? 0 ? 1 : 2,
                    classNameIndex: classNameIndex,
                    isYes: answerValue
                });
            } else {
                this.setState({
                    classNameIndex: answerValue ? answerValue === 'Yes' ? 0 : 1 : null,
                    isYes: answerValue
                });
            }
            if (this.props.containsComment && (questionType === 'YesNoTypeComment' || questionType === 'subQuestions') 
            ) {

                const commentAnswer = state.forms[model][CommentQuestionNum];
                
                const buttonColor = commentAnswer !== null ? (commentAnswer !== 'N*' ? 0 : 1) : 2;
                this.setState({
                    classNameIndex: buttonColor,
                    isYes: commentAnswer !== null ? commentAnswer !== 'N*' ? 'Y*' : 'N*' : commentAnswer,
                    defaultComment: commentAnswer === 'Y*' ? '' : commentAnswer
                });

            } else if (CommentQuestion || questionType === 'Comments') {
                const commentAnswer = state.forms[model][CommentQuestionNum];
                this.setState({
                    defaultComment: commentAnswer
                });
            }

            const dateAnswer = state.forms[model][CommentQuestionNum]; 
            if (CommentQuestion === 'Date' && format(date, 'MM/DD/YYYY') !== dateAnswer && !isDateTouched) {
                this.setState({
                    date: dateAnswer && new Date(dateAnswer)
                });
            }
        }
    }

    onDateChange = (date) => {
        this.setState({
            date,
            isDateTouched: true
        });
        const { model, quesNo } = this.props;
        dispatch(actions.change(`forms.${model}.${Number(quesNo) + 1}`, format(date, 'MM/DD/YYYY')));
    }

    handleChangeLabel = (e) => {
        this.setState({ defaultComment: e.target.value });
    }
    renderQuestions = (type) => { 
        const { question, quesNo, buttons, model } = this.props;
        const { classNameIndex, isYes } = this.state;
        this.loadDefaultValues(store.getState(), model);
        switch (type) {
            case 'YesNoType':
                return (
                    <React.Fragment>
                        <div className="question-row">
                            <div className="question" >
                                    <div className="question-no" >{this.props.customLabel || quesNo}</div>
                                {question}
                            </div>
                            <div className={`buttons`}>
                                {buttons.map((data, index) => (
                                    <button
                                        key={index}
                                        onClick={() =>
                                            this.handleButtons(data.value, index, quesNo, model)}
                                        type="button"
                                        className={(classNameIndex === index) ? 'button-yes' 
                                        : 'button-no'}
                                    >{data.label}</button>
                                ))}
                            </div>
                        </div>
                        {isYes === 'Yes' && this.props.containsComment ?
                            <div>
                                {this.props.CommentQuestion !== 'Date' ? <InputRow
                                    label={this.props.CommentQuestionLabel}
                                    quesNo={(this.props.customLabelForComments || '').toString()}
                                    type="textarea"
                                    placeholder="Comment..."
                                    defaultValue={this.state.defaultComment || ''}
                                    model={`.${this.props.CommentQuestionNum}`}
                                /> :
                                    <div className="question-row" >
                                        <div className="question" >
                                            {this.props.CommentQuestionNum ?
                                                <div
                                                    className="question-no"
                                                >
                                                    {this.props.CommentQuestionNum}
                                                </div> : ''}
                                            {this.props.CommentQuestion}
                                        </div>
                                        <RDatePicker
                                            value={this.state.date}
                                            onChange={this.onDateChange}
                                        />
                                    </div>}
                            </div> : ''}

                    </React.Fragment>
                );
            case 'Comments':
                return (
                    <div className="question" >
                        {<InputRow
                            label={question}
                            quesNo={this.props.customLabel || quesNo}
                            type="textarea"
                            placeholder="Comment..."
                            defaultValue={this.state.defaultComment || ''}
                            model={`.${quesNo}`}
                        />}
                    </div>
                );
            case 'Date':
                return (
                    <div>
                        {isYes && <div className="question-row" >
                            <div className="question" >
                                {quesNo ? <div className="question-no" >{quesNo}</div> : ''}
                                {question}
                            </div>
                            <RDatePicker
                                value={this.state.date}
                                onChange={this.onDateChange}
                            />
                        </div>}
                    </div>
                );
            case 'title':
                return (
                    <div key={question} className="field-heading">{question}
                    </div>
                );
            case 'headingForSubsections': 
                return (
                    <div className="question-row">
                    <div className="question" >
                            <div className="question-no" >{this.props.customLabel || quesNo}</div>
                                {question}:
                    </div>
                    </div>
                );
            case 'YesNoTypeComment' :
                return (
                    <React.Fragment>
                    <div className="question-row">
                            <div className="question" >
                                    <div className="question-no" >{this.props.customLabel || quesNo}</div>
                                {question}
                            </div>
                            <div className="buttons">
                                {buttons.map((data, index) => (
                                    <button
                                        key={index}
                                        onClick={() =>
                                            this.handleButtons(data.value, index, 
                                                quesNo, model)}
                                        type="button"
                                        className={(classNameIndex === index) ? 'button-yes ' : 'button-no'}
                                    >{data.label}</button>
                                ))}
                            </div>
                    </div>
                    {isYes === 'Y*' && this.props.containsComment ?
                    <div>
                        <InputRow
                            label={this.props.CommentQuestionLabel}
                            quesNo={('').toString()}
                            type="textarea"
                            placeholder="Comment..."
                            defaultValue={this.state.defaultComment || ''}
                            model={`.${this.props.CommentQuestionNum}`}
                            onChange = { (e) => this.handleChangeLabel(e)}
                        />
                    {this.state.defaultComment === 'Y*' || this.state.defaultComment === '' ? 
                    <label className="required-label">
                        *Please enter some comment in the comment box.
                    </label> : ''}        
                    </div> : ''}
                    </React.Fragment>
                );
            case 'subQuestions': 
                return (
                    <React.Fragment>
                    <div className="contains-questions">
                    <div className="question-row">
                            <div className="question" >
                                    <div className="question-no" >{this.props.customLabel || quesNo}</div>
                                {question}
                            </div>
                            <div className="buttons">
                                {buttons.map((data, index) => (
                                    <button
                                        key={index}
                                        onClick={() =>
                                            this.handleButtons(data.value, index, quesNo, model)}
                                        type="button"
                                        className={(classNameIndex === index) ? 'button-yes ' : 'button-no'}
                                    >{data.label}</button>
                                ))}
                            </div>
                    </div>
                    {isYes === 'Y*' && this.props.containsComment ?
                    <div>
                        <InputRow
                            label={this.props.CommentQuestionLabel}
                            quesNo={('').toString()}
                            type="textarea"
                            placeholder="Comment..."
                            defaultValue={this.state.defaultComment || ''}
                            model={`.${this.props.CommentQuestionNum}`}
                            onChange = { (e) => this.handleChangeLabel(e)}
                        />
                    {this.state.defaultComment === 'Y*' || this.state.defaultComment === '' ? 
                    <label className="required-label">
                        *Please enter some comment in the comment box.
                    </label> : ''}        
                    </div> : ''}
                    </div>
                    </React.Fragment>
                );
            default:
                return (<div></div>);

        }
    }
    render() {
        const { questionType } = this.props;
        return (
            this.renderQuestions(questionType)
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/RenderQuestion.tsx